import React, { useEffect, useState, useContext } from "react";
import {
  getProductsQty,
  takenQty,
  deleteProductQty,
  getWarehouses,
  getUsers,
  getProducts,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { EditProductQty } from "./form";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { WarehouseContext } from "../../../Utility/UserContext";
import { isReadonlyRoute, NaviGate, warehouse_id } from "../../../Utility/function";
import ShiftModal from "./ShiftModal";
import { useLocation } from "react-router-dom";

const ProductQty_list = () => {
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [productQty, setProductQty] = useState([]);
  const [warehouse, setWarehouses] = useState([]);
  const [users, setUsers] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedProductQty, setSelectedProductQty] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [addoredit, setAddorEdit] = useState();
  const [deleteID, setDeleteID] = useState();
  const [deletemodel, showDeletemodel] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [IN_OUT, setIN_OUT] = useState(null);
  const rolesPerPage = 10;
  const { selectedWarehouse, showLoader, hideLoader, shopItem, UserItem } =
    useContext(WarehouseContext);

   useEffect(() => {
     if (!warehouse_id) {
       toast.warning("Select a Warehouse before Entry");
     }
     fetchWarehouse();
     fetchProducts();
     fetchUsers();
   }, []);

  useEffect(() => {
    fetchProductsQty(1);
  }, [IN_OUT, selectedWarehouse]);

  const openAddModal = () => {
    setAddorEdit(true);
    setShowEditModal(!showEditModal);
  };

  const openEditModal = (cat) => {
    setSelectedProductQty(cat);
    setAddorEdit(false);
    setShowEditModal(!showEditModal);
  };

  const fetchProductsQty = async (page = 1,search=searchText) => {
    showLoader();
    try {
      const response = await getProductsQty(page,search ,IN_OUT, selectedWarehouse?.id);
      if (response.data && response.data.data) {
        setProductQty(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      hideLoader();
    }
  };

  const handleSearch = async (search) => {
    fetchProductsQty(1, search);
    setCurrentPage(1);

  }

  const fetchWarehouse = async () => {
    try {
      const response = await getWarehouses();
      if (response.data && response.data.data) {
        setWarehouses(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await getProducts();
      if (response.data && response.data.data) {
        setProducts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching products data:", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await getUsers();
      if (response.data && response.data.data) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteProductQty(deleteID);
      toast.success("Product Quantity deleted successfully");
      fetchProductsQty(currentPage);
      showDeletemodel(false);
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("Error deleting product");
    }
  };

  const indexOfLastRole = currentPage * rolesPerPage;
  const indexOfFirstRole = indexOfLastRole - rolesPerPage;
  const currentMenus = productQty.slice(indexOfFirstRole, indexOfLastRole);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchProductsQty(pageNumber);
  };

  const formatPrice = (price) => !isNaN(Number(price)) ? Number(price).toFixed(3) : "0.00";

  const ThRow = (bg, text) => (
    <td
      style={{
        backgroundColor: bg ? "#0000ffa3" : "#ff0000b0",
        color: "white",
      }}
    >
      {text}
    </td>
  );

  const [selectedItem, setSelectedItem] = useState();
  const [openTakenModal, setOpenTakenModal] = useState(false);
  const [takenqty, setTakenQty] = useState(0);

  const handleOpenTaken = (item) => {
    setSelectedItem(item);
    setOpenTakenModal(true);
  };

  const handleTaken = async () => {
    setOpenTakenModal(false);
    var payload = {
      ...selectedItem,
      in_or_out: 1,
      qty: takenqty,
      user_id: UserItem?.user_id || "0",
      remaining: 0,
    };
    await takenQty(payload, selectedItem.id);
    toast.success(`${selectedItem?.product_name} - Quantity Taken Successfully `);
    fetchProductsQty(1);
  };

  const handleClear = () => {
    setOpenTakenModal(false);
    setTakenQty(0);
  };

  const [openShiftModal, setOpenShiftModal] = useState(false);

  const handleOpenShiftModal = (item) => {
    setSelectedItem(item);
    setOpenShiftModal(true);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Products Quantity List</h6>

          {false && <div className="d-flex me-3">
          {/* {!readonly && <div className="d-flex me-3"> */}
            <button
              type="button"
              onClick={() => openAddModal()}
              className="btn btn-primary mb-0 text-normal rounded-1"
            >
              Add Product Quantity
            </button>
          </div>}
        </div>
        <hr className='mt-1' />

        <div className="card">
          <div className="card-body">
          <div className="row align-items-center mb-3">
  {/* Search Input */}
  <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-0">
    <div className="d-flex position-relative w-100">
      <input
        type="text"
        className="form-control form-control-sm"
        placeholder="Search..."
        onChange={(e) =>{ 
          handleSearch(e.target.value)
          setSearchText(e.target.value)
        }}
      />
      <img
        src="/assets/images/icons/search.png"
        alt="Search Icon"
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          height: "18px",
          pointerEvents: "none",
        }}
      />
    </div>
  </div>

  {/* Tab Buttons */}
  <div className="col-12 col-md-6 col-lg-8 d-flex justify-content-md-end justify-content-start text-semibold gap-2">
    <div className="tab-container d-flex gap-2 ">
      <button
        className={`tab-button btn btn-outline-primary fw-bold btn-sm ${IN_OUT === 0 ? "active-tab text-white bg-primary" : ""}`}
        // style={{color:"blue"}}
        onClick={() => setIN_OUT(0)}
      >
        Add
      </button>
      <button
        className={`tab-button btn btn-outline-danger fw-bold btn-sm ${IN_OUT === 1 ? "active-tab text-white bg-danger" : ""}`}

        onClick={() => setIN_OUT(1)}
      >
        Taken
      </button>
      <button
        className={`tab-button btn btn-outline-success fw-bold  btn-sm ${IN_OUT === null ? "active-tab text-white bg-success" : ""}`}

        onClick={() => setIN_OUT(null)}
      >
        All
      </button>
    </div>
  </div>
</div>

            <div className="table-responsive">
              <table
                id="example"
                className="table table-sm table-bordered align-baseline"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Warehouse</th>
                    <th>Product</th>
                    <th>In or Out</th>
                    <th>Quantity</th>
                    <th>Purchase Price</th>
                    <th>Sales Price</th>
                    <th>Remaining</th>
                    {/* {!readonly && <th>Actions</th>} */}
                  </tr>
                </thead>
                <tbody>
                  {productQty.length > 0 ? (
                    productQty &&
                    productQty.map((prod, index) => (
                      <tr key={prod.productQty_id}>
                        {ThRow(
                          prod.in_or_out == 0,
                          (currentPage - 1) * rolesPerPage + index + 1
                        )}
                        {ThRow(prod.in_or_out == 0, prod.warehouse_title)}
                        {ThRow(
                          prod.in_or_out == 0,
                          prod.product_name ? prod.product_name : "N/A"
                        )}
                        {ThRow(
                          prod.in_or_out == 0,
                          prod.in_or_out == "0" ? "IN" : "OUT"
                        )}
                        {ThRow(prod.in_or_out == 0, prod.qty)}
                        {ThRow(
                          prod.in_or_out == 0,
                          formatPrice(prod.purchase_price)
                        )}
                        {ThRow(
                          prod.in_or_out == 0,
                          formatPrice(prod.sales_price)
                        )}
                        {ThRow(prod.in_or_out == 0, prod.remaining)}
                        {/* {!readonly && <th>
                          {prod.in_or_out == 0 && prod.remaining != 0 && (
                            <img
                              src="/assets/images/icons/take-cart.png"
                              height={"16px"}
                              style={{ marginRight: "5px" }}
                              onClick={() => handleOpenTaken(prod)}
                            />
                          )}
                          {prod.in_or_out == 0 && prod.remaining != 0 && (
                            <img
                              src="/assets/images/icons/shift-icon.png"
                              height={"16px"}
                              className="ms-2"
                              style={{ marginRight: "5px" }}
                              onClick={() => handleOpenShiftModal(prod)}
                            />
                          )}
                        </th>} */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No products found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />

        </div>

        <div
          className={`modal fade ${openTakenModal ? "show" : ""}`}
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden={!openTakenModal}
          style={{ display: openTakenModal ? "block" : "none" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Take Product
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => handleClear()}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="text-small form-label">
                    Quantity{" "}
                    <span className="text-danger">
                      ({selectedItem?.remaining})
                    </span>
                  </label>
                  <input
                    type="number"
                    className="form-control text-small"
                    value={takenqty}
                    max={selectedItem?.remaining}
                    min={1}
                    onChange={(e) => {
                      if (selectedItem.remaining >= e.target.value) {
                        setTakenQty(e.target.value);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => handleClear()}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    handleTaken();
                    handleClear();
                  }}
                >
                  Take
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      <EditProductQty
        showModal={showEditModal}
        setShowModal={() => openEditModal()}
        selectedProductQty={selectedProductQty}
        fetchdata={() => fetchProductsQty(currentPage)}
        AddorEdit={addoredit}
      />

      <ShiftModal
        show={openShiftModal}
        setShow={setOpenShiftModal}
        selectedItem={selectedItem}
        refreshList={() => fetchProductsQty(currentPage)}
      />
    </div>
  );
};

export default ProductQty_list;
